<template>
    <div class="w-full flex flex-1 gap-x-4 justify-between px-2">
        
        <div v-for="total in totals"
            :key="total.label"
            :class="{ 'hidden': total.hide }"
            class="flex flex-1 no-wrap xs:flex-col md:flex-row gap-x-2 text-center justify-between items-center"
        >
            <h4 class="xs:text-sm md:text-xl flex-1">{{ total.label }}:</h4>
            <h4 class="flex-1" :class="{ 'opacity-50': !total.active }">
                <span class="xs:text-sm sm:text-xl" :class="{ 'font-bold': total.bold, 'text-primary': total.danger }"> {{ total.value | currency }}</span>
            </h4>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
    export default {
        props: {
            selectedValue: Number,
            totalValue: Number,
        },
        
        computed: {
            totals() {
                return [
                    { label: 'Selecionado', active: this.totalValue , value: this.selectedValue, bold: true, hide: !this.selectedValue },
                    { label: 'Total', active: this.totalValue , value: this.totalValue, bold: true },
                    { label: 'Restante', active: this.leftToPay , value: this.leftToPay, bold: false, danger: true },
                    { label: 'Pago', active: this.totalPaidInPayments , value: this.totalPaidInPayments, bold: true },
                ];
            },
            leftToPay () {
                return this.truncate(this.totalValue - this.totalPaidInPayments);
            },
            ...mapGetters('payment', ['totalPaidInPayments'])
        },

        methods: {
            truncate (value) {
                return Math.round(value * 100 + Number.EPSILON) / 100;
            },
        },
    }
</script>